import React from "react";
import membershipContent from "../data/membershipData";
import PageWrapper from "../components/PageWrapper";

const Membership = () => {
  return (
    <PageWrapper>
      <main>
        <section
          className="py-12 sm:py-16 min-h-screen"
          style={{
            backgroundImage: `url('/gradient_bg.svg')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          aria-labelledby="membership-heading"
        >
          <div className="mx-auto max-w-6xl px-6 sm:px-6 lg:px-4 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

            {/* Text block */}
            <div className="order-1 lg:order-1">
              <header>
                <h2 className="text-left text-base font-semibold text-sky-600 font-heading">
                  {membershipContent.sectionTitle}
                </h2>
                <h3 className="mt-2 text-left text-2xl font-semibold tracking-tight text-gray-950 mb-6 font-heading">
                  {membershipContent.title}
                </h3>
              </header>

              {membershipContent.paragraphs.map((paragraph, index) => (
                <p
                  key={`paragraph-${index}`}
                  className="text-gray-700 text-base leading-relaxed mb-2 font-body"
                >
                  {paragraph}
                </p>
              ))}

              <ul className="list-none space-y-2 mb-2">
                {membershipContent.applicationFields.map((field, index) => (
                  <li key={`field-${index}`} className="flex">
                    {/* Bullet */}
                    <span className="flex-shrink-0 mt-1">•</span>
                    {/* Inhalt — mehrzeilige Texte bleiben bündig unter diesem Span */}
                    <span className="ml-3 text-gray-700 text-base leading-relaxed font-body">
                      {field}
                    </span>
                  </li>
                ))}
              </ul>

              <p className="text-gray-700 text-base leading-relaxed mb-2 font-body">
                Nach Eingang deiner Bewerbung melden wir uns bei dir und
                vereinbaren die weiteren Schritte. Wir freuen uns darauf, neue
                engagierte Mitglieder in unserem Verein willkommen zu heißen!
              </p>

              {/* 

              <ul className="list-disc list-inside text-gray-700 text-base leading-relaxed mb-4 font-body">
                {membershipContent.fees.map((fee, index) => (
                  <li key={`fee-${index}`}>{fee}</li>
                ))}
              </ul>
              */}

              <span className="text-gray-700 text-base leading-relaxed font-body">
                E-Mail:{" "}
              </span>
              <a
                href="mailto:info@angelfreunde1866.de"
                className="text-sky-600 hover:text-sky-700 font-body"
              >
                info@angelfreunde1866.de
              </a>
            </div>

            {/* Image block */}
            <figure className="order-2 lg:order-2 w-full flex justify-center">
              <img
                src={membershipContent.image.src}
                alt={membershipContent.image.alt}
                loading="lazy"
                className="rounded-2xl shadow-xl object-cover w-full h-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/placeholder-membership.webp";
                }}
              />
            </figure>
          </div>
        </section>
      </main>

    </PageWrapper>
  );
};

export default Membership;